import styled from "@emotion/styled";

export const StyledChats = styled.div`
  .mention-user-name {
    color: var(--primary);
    font-weight: 500;
    cursor: pointer;
  }
  @media (max-width: 767px) {
    .tenant-flow-open {
      .tenant-flow-back {
        display: block !important;
      }
    }

    .tenant-list {
      display: flex;
    }

    .tenant-flow,
    .chat-view {
      display: none;
    }

    .tenant-flow-open {
      .tenant-flow {
        display: flex !important;
      }
      .tenant-list,
      .chat-view {
        display: none !important;
      }
    }

    .chat-view-open {
      .chat-view {
        display: block !important;
      }
      .tenant-flow,
      .tenant-list {
        display: none !important;
      }
    }
  }
`;
